import React from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import LoginPage from '../pages/LoginPage';

const DEV_AUTH_BYPASS = process.env.REACT_APP_DEV_AUTH_BYPASS === 'true';

/** Inner component that uses MSAL hooks — only rendered when NOT in dev mode */
function MsalProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useIsAuthenticated();
  if (!isAuthenticated) return <LoginPage />;
  return <>{children}</>;
}

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  if (DEV_AUTH_BYPASS) return <>{children}</>;
  return <MsalProtectedRoute>{children}</MsalProtectedRoute>;
}
